
































import Vue, { PropType } from 'vue';
import { directive as onClickaway } from 'vue-clickaway';

export interface NavDropdownItem {
    to: string | null;
    label: string;
    info: string;
    icon: string | string[];
    external?: boolean;
    exact?: boolean;
}

export default Vue.extend({
    name: 'NavigationDropdown',
    directives: { onClickaway },
    props: {
        items: {
            type: Array as PropType<NavDropdownItem[]>,
            required: true,
        },
        top: {
            type: Number,
            required: true,
        },
        matches: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
    },
    data() {
        return {
            open: false,
        };
    },
    computed: {
        filteredItems(): NavDropdownItem[] {
            return this.items.filter(item => item.to !== null);
        },
        isMatch(): boolean {
            return this.matches.some(match => this.$route.path.startsWith(match));
        },
    },
    methods: {
        away() {
            this.open = false;
        },
    },
});
